export function queryParamFormOpener() {
  const urlParams = new URLSearchParams(window.location.search)
  const formToOpen = urlParams.get("open_form")
  if (!formToOpen) return
  const modal = document.querySelector(`#${formToOpen}`)
  if (!modal) return
  modal.classList.add("show")
}
